import { ProjectDTO } from '../dtos';
import { ProjectsTable } from '../views';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils';

export const GET_PROJECTED_MARGIN = (project: ProjectsTable | ProjectDTO): number => {
	let projectedMargin: number = null;
	if (IS_NOT_NULL_OR_UNDEFINED(project)) {
		const bestRateInCents: number = project.bestRate;
		const lastBidInCents: number = project.lastBid;
		if (IS_NOT_NULL_OR_UNDEFINED(bestRateInCents) && IS_NOT_NULL_OR_UNDEFINED(lastBidInCents)) {
			const bestRate = bestRateInCents / 100,
				lastBid = lastBidInCents / 100;
			projectedMargin = (lastBid - bestRate) / lastBid;
		}
	}
	return projectedMargin;
};
